import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OpenGraphData } from "../types/api";
import { getOpenGraphData } from "../actions/sharedActions";

interface OpenGraphState {
  data: { [url: string]: OpenGraphData | null };
  status: { [url: string]: "idle" | "loading" | "succeeded" | "failed" };
  error: { [url: string]: string | null };
}

const initialState: OpenGraphState = {
  data: {},
  status: {},
  error: {},
};

const openGraphSlice = createSlice({
  name: "openGraph",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOpenGraphData.pending, (state, action) => {
        const url = action.meta.arg;
        state.status[url] = "loading";
        state.error[url] = null;
      })
      .addCase(getOpenGraphData.fulfilled, (state, action) => {
        const { url, data } = action.payload;
        state.data[url] = data;
        state.status[url] = "succeeded";
        state.error[url] = null;
      })
      .addCase(getOpenGraphData.rejected, (state, action) => {
        const url = action.meta.arg;
        const { message } = action.payload || { message: "Unknown error" };
        state.status[url] = "failed";
        state.error[url] = message;
      });
  },
});

export const {} = openGraphSlice.actions;
export const opengraphReducer = openGraphSlice.reducer;
